import { Component } from '@angular/core';
import { WeekDayComponent } from './week-day.component';

@Component({
  selector: 'joii-week-days-header',
  imports: [WeekDayComponent],
  template: `
    <div class="week-day-row">
      <joii-week-day label="Sun" name="Sunday" />
      <joii-week-day label="Mon" name="Monday" />
      <joii-week-day label="Tue" name="Tuesday" />
      <joii-week-day label="Wed" name="Wednesday" />
      <joii-week-day label="Thu" name="Thursday" />
      <joii-week-day label="Fri" name="Friday" />
      <joii-week-day label="Sat" name="Saturday" />
    </div>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }
    .week-day-row {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 8px;
      margin-top: 16px;
    }
  `,
})
export class WeekDaysHeaderComponent {}
